import { Injectable, InjectionToken } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { CatalogoComponent } from '../forms/produtos/mercadolivre/catalogo/catalogo.component';
import { REGISTRY } from '../interfaces/registry-services';
import { ObjectUtil } from '../system-utils/utils/ObjectUtil';
import { DialogService } from './dialog.service';
import { HTTPService } from './http.service';
import { SnackbarService } from './snackbar.service';
import { MeliCategoryPredictorComponent } from '../forms/produtos/mercadolivre/meli-edit-form/meli-category-predictor/meli-category-predictor.component';

@Injectable()
export class MeliServices {
    getProduct(id: any) {
      throw new Error('Method not implemented.');
    }

    public static TOKEN = new InjectionToken<MeliServices>('MeliServices');
    constructor(private http:HTTPService, private snackBar:SnackbarService, private dialogServices:DialogService){

    }

    sub:Subscription;
    sub2:Subscription;

    ngOnDestroy(){
        if (this.sub!= null ) {this.sub.unsubscribe();}
        if (this.sub2!= null ) {this.sub2.unsubscribe();}
    }

    getProdutoCatalogoMLB(value, codeCompany ){
        return new Promise(async (resolve,reject)=>{
            let ob = {
                codeCompany : codeCompany,
                method: "GET",
                serviceName: "FindProductCatalog"
              }
    
            ob['params']=[{
                key:"@MLB_CATALOGO",
                value:'encodeString('+value +')'
                //value: value
                },
            ];

          
            this.sub2 = this.http.post(ob, 'MeliNotifications/getGenericMeli', false, true, false).subscribe(data => {
                if (ObjectUtil.isNotEmpty(data['resultado'])) {
                    resolve(data['resultado']);
                }
            }, error => {
                reject(error);
            });
    
        });
    }

    getProdutoCatalogo(value, codeCompany, identifier){
        
        return new Promise(async (resolve,reject)=>{
            let ob = {
                codeCompany : codeCompany,
                method: "GET",
                serviceName: identifier ? "FindProductById" : "FindProductByQuery"
              }

            if ( !identifier && !value){
                value='null';
            }

            if ( identifier ){
                value = identifier;
            }
    
            ob['params']=[{
                key:"@TEXT",
                value:'encodeString('+value +')'
                //value: value
                },
            ];

          
            this.sub2 = this.http.post(ob, 'MeliNotifications/getGenericMeli', false, true, false).subscribe(data => {
                if (ObjectUtil.isNotEmpty(data['resultado'])) {
                    resolve(data['resultado']);
                }
            }, error => {
                reject(error);
            });
    
        });

    }

    getAnuncio(mlb, codeCompany){
        
        return new Promise(async (resolve,reject)=>{
            let ob = {
                codeCompany : codeCompany,
                method: "GET",
                serviceName: "GetItem"
              }
    
            ob['params']=[{
                key:"@MLB",
                value:mlb
            }];
        
            
          
            this.sub2 = this.http.post(ob, 'MeliNotifications/getGenericMeli', false, true, false).subscribe(data => {
                if (ObjectUtil.isNotEmpty(data['resultado'])) {
                    resolve(data['resultado']);
                }

            }, error => {
                reject(error);
            });
    
        });

    }

    getOrderByPackId(data, codeCompany){

        return new Promise(async (resolve,reject)=>{
            let ob = {
                codeCompany : codeCompany,
                method: "GET",
                serviceName: "GetOrderByPackId"
              }
    
            ob['params']=[{
                key:"@PACKID",
                value:data
            }];
        
            
          
            this.sub2 = await this.http.post(ob,'MeliNotifications/getGenericMeli',false,true,false).subscribe(data=>{
                if ( ObjectUtil.isNotEmpty( data['resultado'])){
                    if ( ObjectUtil.isNotEmpty(data['resultado']['orders'])){
                        resolve( String(data['resultado']['orders'][0]['id']));
                    }
                }
            },error=>{
                reject(error);
            });
    
        });
        
    }


    getInvoice(data, codeCompany){

        return new Promise(async (resolve,reject)=>{
            let ob = {
                codeCompany : codeCompany,
                method: "GET",
                serviceName: "GetInvoiceByOrderId"
              }
    
            ob['params']=[{
                key:"@ORDERID",
                value:data
            },
            {
                key:"@CODECOMPANY",
                value:codeCompany
            }];
        
            
          
            this.sub2 = await this.http.post(ob,'MeliNotifications/getGenericMeli',false,true,false).subscribe(data=>{
                if ( ObjectUtil.isNotEmpty( data['resultado'])){
                    if ( ObjectUtil.isNotEmpty(data['resultado']['id'])){
                        resolve( String(data['resultado']['id']));
                    }
                }
            },error=>{
                reject(error);
            });
    
        });
        
    }

    getCatalog(data){
        let dados = data[0];

        let ob = {
            codeCompany : dados['CODECOMPANY'],
            method: "GET",
            serviceName: "FindCatalogo",
          }

        ob['params']=[{
            key:"@MLB_ANUNCIO",
            value:dados['MLB_ANUNCIO']
        }];
    
        
      
        this.sub = this.http.post(ob,'MeliNotifications/getGenericMeli',false,true,false).subscribe(data=>{
            if ( ObjectUtil.isNotEmpty( data['resultado'])){
                let resultado  = data['resultado'];

                let toadd:{buy_box_eligible:boolean, id:number, status:string}[] = [];

                let isElegible = false;
                if ( ObjectUtil.isNotEmpty(resultado['buy_box_eligible'] )){
                    if ( resultado['buy_box_eligible']  == true ){
                        isElegible = true;
                    }
                }

                let variations:{buy_box_eligible:boolean, id:number, status:string}[] = resultado['variations'];
                if ( variations != null && variations.length > 0 ){
                    for ( let i = 0; i < variations.length; i++){
                        let variation:{buy_box_eligible:boolean, id:number, status:string} = variations[i];
                        if ( variation.buy_box_eligible == true && variation.status =='READY_FOR_OPTIN'){
                            isElegible = true;
                            toadd.push(variation);
                        }
                    }
                }else{
                    if ( isElegible ){
                        if ( resultado['status']=="READY_FOR_OPTIN"){
                            toadd.push({buy_box_eligible:isElegible, id: 0, status: resultado['status']});
                        }
                    }
                }
                
                
                if ( toadd.length > 0 ){
                    
                    this.dialogServices.errorDialoag = false;
                    this.dialogServices.infoDialog = false;
                    this.dialogServices.btnSim ="Vincular";
                    this.dialogServices.btnNao = "Cancelar";
                    this.dialogServices.title = "Vínculo do Catálogo";
                    this.dialogServices.openGenericDialog(CatalogoComponent, dados, (valor)=>{

                    });
                    //this.dialogServices.opopenDialog("Deseja vincular o anúncio " + dados['MLB_ANUNCIO'] +" no catálogo?",null,(data)=>{
                            
                    //});
                    

                }else{
                    let message = null;
                    if ( isElegible && toadd.length == 0){
                        message = `Anúncio ${data['resultado']['id']} é elegível a catálogo, porém, não se encontra no status para vincular`;
                    }else{
                        message = `Anúncio ${data['resultado']['id']} não é elegível a catálogo.`;
                    }

                    this.dialogServices.infoDialog = true;
                    this.dialogServices.openDialog(message);
                    this.dialogServices.infoDialog = false;
                }
            }
        });
        

    }

    vincularCatalogo(item: any, codeCompany) {
        return new Promise(async (resolve,reject)=>{
            let ob = {
                codeCompany : codeCompany,
                method: "POST",
                serviceName: "VincularCatalogo"
              }
    
            let body = {
                'item_id':item['mlb'],
                'catalog_product_id':item['catalog_product_id']
            }
            
            ob['body'] = JSON.stringify(body);
            
          
            this.sub2 = await this.http.post(ob,'MeliNotifications/getGenericMeli',false,true,false).subscribe(data=>{
                if ( ObjectUtil.isNotEmpty( data['resultado'])){
                    resolve(data['resultado'])
                }
            },error=>{
                reject(error);
            });
    
        });
        
      }
 
      
      predicaoCategoria(selectedItem:object[], component){
        if ( selectedItem.length == 0 ){
            this.snackBar.showError("Selecione um produto para predição de categoria.");
            return;
        }

        if ( selectedItem.length > 1 ){
            this.snackBar.showError("Selecione apenas um produto para predição de categoria.");
            return;
        }
        let selectedItemDetail = selectedItem[0];

        let title = selectedItemDetail['title']||selectedItemDetail['TITLE'];
        let codecompany = selectedItemDetail['codecompany']||selectedItemDetail['CODECOMPANY'];
        let codeproduct = selectedItemDetail['codeproduct']||selectedItemDetail['CODEPRODUCT'];
        let codemeli = selectedItemDetail['codemeli']||selectedItemDetail['CODEMELI'];
        let codecontract = selectedItemDetail['codecontract']||selectedItemDetail['CODECONTRACT'];

        if ( !ObjectUtil.isNotEmpty(title) ){
              this.snackBar.showError("Para predição de categoria é necessário preencher o título.");
              return;
            }
    
        
            let ob = {
              codeCompany : codecompany,
              method: "GET",
              serviceName: "CatPrediction",
            }
        
            ob['params']=[{
                key:"?q",
                value:`encodeString(${title})`
            }];
        
            
            
            this.http.post(ob,'MeliNotifications/getGenericMeli',false,true,false).subscribe(data=>{
              
              let prediction:object[] = data['resultado'];

              if ( prediction == null || prediction == undefined || prediction.length == 0 ){
                  this.snackBar.showError("Nenhuma predição encontrada para o título informado.");
                  return;
              }
              
              this.dialogServices.openGenericDialog(MeliCategoryPredictorComponent,prediction,(value)=>{
                  let selectedPrediction = value;
                  if ( selectedPrediction != null ){
                   let category_id = selectedPrediction['category_id'];
                   if ( component!= null && component.formGroup != null && component.formGroup.get('CATEGORY_ID') != null   ){
                        component.formGroup.get('CATEGORY_ID').setValue(category_id);
                   }else{
                           let body ={
                                'entityName':'Mktpmeli',
                                'CODECONTRACT': codecontract,
                                'CODECOMPANY': codecompany,
                                'CODEMELI': codemeli,
                                'CODEPRODUCT': codeproduct,
                                'CATEGORY_ID': category_id
                        }
                            this.http.post(body, 'JsonBrokerServices/save', false, true, false).subscribe({
                                next:(result)=>{
                                    this.snackBar.showSuccess("Categoria atualizada com sucesso.");
                                },
                                error:(error)=>{
                                    throw error;
                                }
                                
                            });
                   }
                   
                  }
              })
            },error=>{
              throw error;
            });
      }
}